export default function Navbar() {
  return (
    <div className="navContainer">
      <nav className="nav">
        <ul>
          <NavigationLink href="/">Home</NavigationLink>
          <NavigationLink href="/projects">Projects</NavigationLink>
          <NavigationLink href="/about">About</NavigationLink>
          <NavigationLink href="/contact">Contact</NavigationLink>
        </ul>
      </nav>
    </div>
  );
}

function NavigationLink({ href, children, ...linkProps }) {
  const currentPath = window.location.pathname;
  return (
    <li className={currentPath === href ? "active" : ""}>
      <a href={href} aria-current={currentPath === href ? "page" : undefined} {...linkProps}>
        {children}
      </a>
    </li>
  );
}
